module.exports = __webpack_public_path__ + "img/CRM.6ef095d4.svg";